
import React from 'react';
import MultiSelectGroup from './services/MultiSelectGroup';
import SwitchesGroup from './services/SwitchesGroup';
import EventRoomSection from './services/EventRoomSection';
import ObservationsSection from './services/ObservationsSection';

interface ServicesFormProps {
  readOnly?: boolean;
}

const ServicesForm = ({ readOnly = false }: ServicesFormProps) => {
  return (
    <div className="space-y-6">
      <MultiSelectGroup readOnly={readOnly} />
      <SwitchesGroup readOnly={readOnly} />
      <EventRoomSection readOnly={readOnly} />
      <ObservationsSection readOnly={readOnly} />
    </div>
  );
};

export default ServicesForm;
